<template lang="pug">
.articleStory-middle--governmentStyle
  .articleStory-contentTop
    .articleStory-left
      .articleStory-governmentStory {{ info.content }}

    .articleStory-right(v-if='info.thumbnailUrl && info.thumbnailUrl2')
      .articleStory-swiperArrows
        .articleStory-swipperArrowLeft(@click='$refs.slick.prev()')
          .articleStory-arrowLeft
        .articleStory-swipperArrowRight(@click='$refs.slick.next()')
          .articleStory-arrowRight
      Slick(
        :options='slickOptions'
        ref='slick'
        )
          
        .articleStory-governmentImageCarousel
          .articleStory-imageInCarousel(
            v-if="info.thumbnailUrl" 
            :style="'background-image: url(' + info.thumbnailUrl +')'"
            )
            span.articleStory-counterCarousel 1/2
          .articleStory-imageCaption.articleStory-imageCaption--withCounter
            span.articleStory-imageCaption--ellipsis2(v-if="info.thumbnailTitle") {{info.thumbnailTitle}}
        .articleStory-governmentImageCarousel
          .articleStory-imageInCarousel(
            v-if="info.thumbnailUrl2" 
            :style="'background-image: url(' + info.thumbnailUrl2 +')'"
            )
            span.articleStory-counterCarousel 2/2
          .articleStory-imageCaption.articleStory-imageCaption--withCounter
            span.articleStory-imageCaption--ellipsis2(v-if="info.thumbnailTitle2") {{info.thumbnailTitle2}}
    
    .articleStory-right(v-else-if='info.thumbnailUrl || info.thumbnailUrl2')
      .articleStory-governmentImageCarousel
        .articleStory-imageInCarousel(
          :style="'background-image: url(' + (info.thumbnailUrl || info.thumbnailUrl2) +')'"
          )
        .articleStory-imageCaption(v-if="info.thumbnailTitle || info.thumbnailTitle2" )
          span.articleStory-imageCaption--ellipsis2 {{info.thumbnailTitle || info.thumbnailTitle2}}

  .articleStory-contentBottom
    .articleStory-subdescription--governmentStyle {{ "最新時間 " + time }}

</template>

<script>
import { getCategoryImgURL } from '@/plugins/tool.js';
import Slick from 'vue-slick';

export default {
  components: {
    Slick
  },
  props: {
    info: Object,
    staticData: Object
  },
  data() {
    return {
      defaultImg:
        "background-image: url('" + getCategoryImgURL('/fig-link.png') + "');",
      slickOptions: {
        slidesToShow: 1,
        swipeToSlide: true,
        variableWidth: true,
        centerMode: false,
        infinite: true,
        arrows: false,
        autoplay: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        draggable: true,
        edgeFriction: 0.3,
        swipe: true,
        prevArrow: 'slick-prev'
      }
    };
  },
  methods: {},
  computed: {
    time() {
      if (!this.info.updatedAt) {
        return '';
      }
      var t = this.info.updatedAt.split('T');
      var date = t[0].split('-').join('/');
      var time = t[1].substring(0, 5);
      return date + ' ' + time;
    }
  }
};
</script>

<style scoped src="./gov_announce_story_body.vue.css"></style>
